import { getSharedSportsFiCookieDomain } from '@/lib/auth/sharedCookieDomain';
import { deleteCookie, getCookie, setCookie } from '@/lib/utils/cookies';

const SESSION_ACTIVE_ORG_ID = 'active-org-id';

export const COOKIE_TEMP_ORG_ID = 'temp-org-id';

function getActiveOrganisationCookieDomain(): string | undefined {
  if (typeof window === 'undefined') {
    return getSharedSportsFiCookieDomain();
  }

  return getSharedSportsFiCookieDomain(window.location.hostname);
}

export function setTempOrgIdCookie(orgId: string): void {
  setCookie(COOKIE_TEMP_ORG_ID, orgId, getActiveOrganisationCookieDomain());
}

export function deleteTempOrgIdCookie(): void {
  deleteCookie(COOKIE_TEMP_ORG_ID, getActiveOrganisationCookieDomain());
}

export function readTempOrgIdCookie(): string | null {
  return getCookie(COOKIE_TEMP_ORG_ID);
}

export function readSessionActiveOrgId(): string | null {
  if (typeof window === 'undefined') return null;

  const stored = sessionStorage.getItem(SESSION_ACTIVE_ORG_ID);

  if (stored) {
    return stored;
  }

  const cookieValue = readTempOrgIdCookie();

  if (cookieValue) {
    sessionStorage.setItem(SESSION_ACTIVE_ORG_ID, cookieValue);
  }

  return cookieValue;
}

type WriteOptions = {
  persistCookie?: boolean;
  syncCookie?: boolean;
};

export function setSessionActiveOrgId(
  orgId: string,
  { persistCookie = true, syncCookie = true }: WriteOptions = {}
): void {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.setItem(SESSION_ACTIVE_ORG_ID, orgId);

  if (!syncCookie) {
    return;
  }

  if (persistCookie) {
    setTempOrgIdCookie(orgId);
  } else {
    deleteTempOrgIdCookie();
  }
}

export function setSessionActiveOrgFromCookie(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const cookieValue = readTempOrgIdCookie();

  if (cookieValue) {
    setSessionActiveOrgId(cookieValue, { syncCookie: false });
  }
}

export function clearSessionActiveOrgId(): void {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.removeItem(SESSION_ACTIVE_ORG_ID);
  deleteTempOrgIdCookie();
}
